import { Box, Text } from '@bechtel/gds';
import { DataType } from '@bechtel/sr-types';
import { find } from 'lodash';
import { FC } from 'react';
import { MetadataText, MultiLingualText, useTableMetadataContext } from '~/components';

interface HeaderTileProps {
  label: string;
  // In case we want to use a different metadataColumn in the Tile
  memberName?: string;
  value: number | null;
  numberOfCables?: number;
}

export const HeaderTile: FC<HeaderTileProps> = ({ label, value, numberOfCables, memberName }) => {
  const tableMetadata = useTableMetadataContext();
  const metadataColumn = find(tableMetadata?.metadataColumns, (item) =>
    memberName ? item.memberName === memberName : item.memberName === label
  );

  if (!tableMetadata) return;

  return (
    <Box flexDirection={{ sm: 'column' }}>
      {metadataColumn && !memberName ? (
        <MetadataText metadataTable={tableMetadata} memberName={label} color="primary.700" size="300" />
      ) : (
        <MultiLingualText color="primary.700" size="300">
          {label}
        </MultiLingualText>
      )}

      <Box pt={{ sm: '200' }}>
        <Text color={typeof value === 'number' && value < 0 ? 'readonlyRed' : 'readonlyBlue'} size="400" weight="600">
          {metadataColumn?.dataType === DataType.NUMBER ? Number(value).toFixed(metadataColumn?.decimals) : value}
          {numberOfCables && ` (${numberOfCables})`}
        </Text>
      </Box>
    </Box>
  );
};
